(function() {
  // Skip entire animation for users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var loaderEl = document.getElementById('proart-loader');
    if (loaderEl) loaderEl.style.display = 'none';
    document.body.removeAttribute('data-loading');
    document.dispatchEvent(new CustomEvent('proart:loaded'));
    return;
  }

  var loader = document.getElementById('proart-loader');
  if (!loader) return;

  var logo = loader.querySelector('.loader-logo');
  var barFill = loader.querySelector('.loader-bar-fill');
  var panelTop = loader.querySelector('.loader-panel-top');
  var panelBottom = loader.querySelector('.loader-panel-bottom');

  var exited = false;

  // Entry animation — wait for GSAP to be available
  function initLoader() {
    if (typeof gsap === 'undefined') {
      // GSAP not yet loaded, skip animation gracefully
      exitLoader();
      return;
    }

    gsap.set(logo, { scale: 0.8, opacity: 0 });
    gsap.to(logo, { scale: 1, opacity: 1, duration: 0.8, ease: 'power2.out' });
    gsap.to(barFill, { width: '100%', duration: 1.2, ease: 'power1.inOut' });
  }

  function exitLoader() {
    if (exited) return;
    exited = true;

    if (typeof gsap === 'undefined') {
      // Fallback: instant hide without animation
      loader.style.display = 'none';
      document.body.removeAttribute('data-loading');
      document.dispatchEvent(new CustomEvent('proart:loaded'));
      return;
    }

    gsap.to(logo, { scale: 1.1, opacity: 0, duration: 0.6, ease: 'power2.inOut' });
    gsap.to(panelTop, {
      y: '-100%',
      duration: 0.6,
      ease: 'power2.inOut',
      delay: 0.1
    });
    gsap.to(panelBottom, {
      y: '100%',
      duration: 0.6,
      ease: 'power2.inOut',
      delay: 0.1,
      onComplete: function() {
        loader.style.display = 'none';
        document.body.removeAttribute('data-loading');
        document.dispatchEvent(new CustomEvent('proart:loaded'));
      }
    });
  }

  // Start entry animation immediately
  initLoader();

  // Exit on window load
  if (document.readyState === 'complete') {
    setTimeout(exitLoader, 500);
  } else {
    window.addEventListener('load', function() {
      exitLoader();
    });
    // Safety fallback: never show loader for more than 4 seconds
    setTimeout(exitLoader, 4000);
  }
})();
